import React from 'react';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from '../../shared/keycloak';
import { PageLoader } from '../Loader';

interface KeycloakProviderProps {
  children: React.ReactNode;
}

const KeycloakProvider = ({ children }: KeycloakProviderProps) => {
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ onLoad: 'login-required' }}
      LoadingComponent={<PageLoader />}
    >
      {children}
    </ReactKeycloakProvider>
  );
};

export default KeycloakProvider;
